















import Vue from "vue";
import { Tutor } from "../types";
import TutorCertification from "./TutorCertification.vue";
import TutorHeadShot from "./TutorHeadShot.vue";
import TutorLocation from "./TutorLocation.vue";
// import TutorSpecialAvailability from "./TutorSpecialAvailability.vue";
import TutorDisplayName from "./TutorDisplayName.vue";

export default Vue.extend({
  props: {
    tutor: {
      type: Object as () => Tutor,
      required: true
    },
    tagName: {
      type: String,
      required: false,
      default: (): string => "a"
    }
  },

  computed: {
    attrBindings(): object {
      const bindings: { [key: string]: any } = {};

      if (this.tagName.toLowerCase() === "a") {
        bindings.href = `/tutors/${this.tutor.id}`;
      }

      return bindings;
    }
  },

  components: {
    TutorCertification,
    TutorHeadShot,
    TutorDisplayName,
    TutorLocation
  }
});
